import { createSelector } from 'reselect';

import getCurrentUser from '@core/reducers/user/selectors/getCurrentUser';
import getPropFromModule from './getPropFromModule';
import getPropFromSession from './getPropFromSession';

import { AGE_VALIDATION_AGE_SESSION_KEY } from '../constants';

export const getValidationIsOfAge = createSelector(
  state => getPropFromModule(state, 'isOfAge'),
  () => getPropFromSession(AGE_VALIDATION_AGE_SESSION_KEY),
  getCurrentUser,
  (isOfAge, sessionAgeValidationIsOfAge, currentUser) =>
    currentUser?.isOfAge ? '' : isOfAge || sessionAgeValidationIsOfAge,
);

export default getValidationIsOfAge;
